import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable, of } from 'rxjs';
import {
  PaymentExecutionV1Request,
  PaymentExecutionV1Response,
  PaymentInquiryV1Response,
  PaymentPreviewHostedPaymentV1Response,
  PaymentPreviewV1Request,
  PaymentPreviewV1Response,
  PayOnAccountPaymentPreviewV1Request,
  PayOnAccountPaymentPreviewV1Response,
} from '../models';
import { PaymentInformationService } from './payment-information.service';

/* istanbul ignore next */
export class PaymentInformationPaymentLinksService extends PaymentInformationService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  updateHostedPaymentPreviewV1() {
    return of();
  }

  updatePaymentPreviewV1(
    tenantId: string,
    paymentPreviewV1Request: PaymentPreviewV1Request,
  ): Observable<PaymentPreviewV1Response> {
    return this.httpClient.put<PaymentPreviewV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/paymentlinks/preview`,
      paymentPreviewV1Request,
    );
  }

  getHostedPaymentPreviewV1(): Observable<PaymentPreviewHostedPaymentV1Response> {
    return of(null);
  }

  getPaymentPreviewV1(
    tenantId: string,
    paymentReference: string,
  ): Observable<PaymentPreviewV1Response> {
    return this.httpClient.get<PaymentPreviewV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/paymentlinks/preview/paymentreference/${paymentReference}`,
    );
  }

  getPayOnAccountPaymentPreviewV1(
    tenantId: string,
    paymentReference: string,
  ): Observable<PayOnAccountPaymentPreviewV1Response> {
    return this.httpClient.get<PayOnAccountPaymentPreviewV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/paymentlinks/preview/paymentreference/${paymentReference}`,
    );
  }

  executePaymentV1(
    tenantId: string,
    paymentReference: string,
    transactionReference: string,
    paymentExecutionV1Request: PaymentExecutionV1Request,
  ): Observable<PaymentExecutionV1Response> {
    return this.httpClient.post<PaymentExecutionV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/paymentlinks/execution/paymentreference/${paymentReference}/transactionreference/${transactionReference}`,
      paymentExecutionV1Request,
    );
  }

  getBuyerAccountsV1() {
    return of({ buyerAccounts: [] });
  }

  GetPayOtherDocuments() {
    return of();
  }

  /** istanbul ignore next */
  updatePaymentPreviewPayOnAccountV1(
    tenantId: string,
    payOnAccountPaymentPreviewV1Request: PayOnAccountPaymentPreviewV1Request,
  ) {
    return this.httpClient.put<PayOnAccountPaymentPreviewV1Response>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment/paymentlinks/payonaccount/preview`,
      payOnAccountPaymentPreviewV1Request,
    );
  }

  getPaymentByReferenceV1(tenant: string, paymentReference: string) {
    return this.httpClient.get<PaymentInquiryV1Response>(
      `${this.baseUrl}/v1/tenants/${tenant}/paymentlinks/paymentinquiry/paymentreference/${paymentReference}`,
    );
  }
}
